module.exports = __webpack_public_path__ + "static/red_dragon-97e397b6d35de52bb0e5e668fe34ade8.png";